import React, { useContext } from 'react';

import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';

import AppRoutes, { PageRoute } from './AppRoutes';
import { Layout } from './components/Layout';

import './custom.css';
import { Box, Button, Stack, Typography } from '@mui/material';
import { UserContext, UserLoginStatus } from './components/UserProvider';
import Login from './components/Login';

import LockOpenIcon from '@mui/icons-material/LockOpen';
import { User, getUser, getUserAdminWorkshops, isAdminUser, isGlobalAdmin } from './components/types/User';
import { SnackbarProvider } from './contexts/SnackBarContext';

const PrivateRoutes = () => {
   let user = React.useContext(UserContext);
   let loggedIn = user.loginStatus === UserLoginStatus.LoggedIn;

   console.log(user);
   console.log('logged in: ', loggedIn);

   return (
      loggedIn ? <Outlet /> : <LoginComponent />
   )
}

const LoginComponent = () => {
   return (
   <Box display={'flex'}
        justifyContent={'center'}
        alignItems="center"
        minHeight="75vh"> 
      <Stack direction={'column'}>
            <Typography variant='bold'>Login required.</Typography>
            <Typography variant='body1'>Please use OPC Foundation login credentials</Typography>
            <Button startIcon={<LockOpenIcon/>} href='/api/account/login'>Go to opcfoundation.org to log in</Button>
      </Stack>
   </Box>)
}

function App () {
    const title = "IOP Workshop";
    const subtitle = "OPC Interoperabilility Workshop";

   const location  = useLocation();
   const background = location?.state?.background;

   const userContext = React.useContext(UserContext);
   const [adminUser, setAdminUser] = React.useState<boolean>();
   const [error, setError] = React.useState<String>();

    React.useEffect(() => {
        if (!userContext?.user.id) {
            setAdminUser(false);
            return;
        }
        isAdminUser(userContext.user.id, new AbortController()).then(response => setAdminUser(response)).catch(error => setError(error));
  }, [userContext]);

   const [pages, modals] = 
      AppRoutes.reduce((result: [PageRoute[], PageRoute[]], element) => { result[(element.modal?1:0)].push(element); return result; }, [[], []]);

   React.useEffect(() => {
      document.title = title;
   }, [title]);

   return (
       <React.StrictMode>
           <SnackbarProvider>
                <Layout topMenu={userContext.loginStatus === UserLoginStatus.LoggedIn ? AppRoutes:[]} title={title} subtitle={subtitle}>
                    <Routes location={background || location}>
                        <Route path='/login' element={<Login/>} />
                        <Route element={<PrivateRoutes/>}>
                            { pages.filter(page => (page?.administrator) ? adminUser : true ).map((route, index) => {
                                const { element, ...rest } = route;
                                return <Route key={index} {...rest} element={element} />;
                            })}
                        </Route>
                    </Routes>

                    {/*routes for modals*/}
                    <Routes>
                        {background && modals.map((route, index) => {
                            const { element, ...rest } = route;
                            return <Route key={index} {...rest} element = {element} />;
                        })}
                    </Routes>
                </Layout>
           </SnackbarProvider>
      </React.StrictMode>
   );
}

// here app catches the suspense from page in case translations are not yet loaded
export default function WrappedApp() {
   return (
      <React.Suspense fallback="Translations are loading...">
         <App />
      </React.Suspense>
   );
}